import React from 'react';
import './Marquee.css';

const items = [
  'CUSTOM SOFTWARE',
  'PROCESS AUTOMATION',
  'SYSTEM INTEGRATION',
  'WORKFLOW INTELLIGENCE',
  'DASHBOARDS & ANALYTICS',
  'END-TO-END DELIVERY',
];

function Marquee() {
  // Duplicate items for seamless infinite scroll
  const allItems = [...items, ...items];

  return (
    <div className="marquee-wrap">
      <div className="marquee">
        {allItems.map((item, i) => (
          <span key={i}>{item}</span>
        ))}
      </div>
    </div>
  );
}

export default Marquee;
